module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAiCAYAAAA+stv/AAAAAXNSR0IArs4c6QAAAINJREFUWEdjZBhgwEiW/fX1TLpqjxRgepl//f93IXHBA3LMIssBxqvS+P/++PsBbuF/ho8X4ucKjDpgNARGQ2A0BEZDYDQEhmYIGCxK/k+Oy6mlh3HUAQMeAuTE5WiLaDQERkNgNARGQ2A0BAY8BNTnJvFysjJeQKrIPl+Im2tATsUGAD2UCQKARfnaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/img/shou1.png
// module id = HLIp
// module chunks = 25